/**
 * Constant content definitions for sensenet
 */
export class ConstantContent {}
ConstantContent.VISITOR_USER = {
  Id: 6,
  DisplayName: 'Visitor',
  Domain: 'BuiltIn',
  Name: 'Visitor',
  Path: '/Root/IMS/BuiltIn/Portal/Visitor',
  LoginName: 'Visitor',
  Type: 'User'
};
ConstantContent.PORTAL_ROOT = {
  Id: 2,
  Path: '/Root',
  Name: 'Root',
  DisplayName: 'Root',
  Type: 'PortalRoot'
};
ConstantContent.EMPTY_CONTENT = {
  Id: 0,
  Path: '',
  Name: '',
  DisplayName: '',
  Type: ''
};
//# sourceMappingURL=ConstantContent.js.map